export class ActualizacionModel {
    TipoPersona: string;
    TipoDoc: string;
    Identificacion: string;
    LugarExpDoc: string;
    NombreCompleto: string;
    Nombre: string;
    Nombre1: string;
    Apellido: string;
    Apellido1: string;
    RazonSoc: string;
    Correo: string;
    Celular: string;
    Telefono: string;
    DeptoCod: string;
    DeptoNom: string;
    MunCod: string;
    MunNom: string;
    Direccion: string;
    EsPropietario: boolean;
    ModificarNomSusc: boolean;
    PorcPropMayor: boolean;
    NumeroCuenta: string;
    AutorizaInfo: string;
    AceptaTratDatosPer: boolean;
    RecibirFactElect: boolean;
    MatCatastral: string;
    FechaCreacion: Date;




    constructor(
        TipoPersona?,TipoDoc?,Identificacion?,LugarExpDoc?,NombreCompleto?,Nombre?,Nombre1?,Apellido?,Apellido1?,RazonSoc?,Correo?,Celular?,Telefono?,DeptoCod?,
        DeptoNom?,MunCod?,MunNom?,Direccion?,EsPropietario?,ModificarNomSusc?,PorcPropMayor?,NumeroCuenta?,AutorizaInfo?,AceptaTratDatosPer?,RecibirFactElect?,
        MatCatastral?,FechaCreacion?) {
        this.TipoPersona = TipoPersona;
        this.TipoDoc = TipoDoc;
        this.Identificacion = Identificacion;
        this.LugarExpDoc = LugarExpDoc;
        this.NombreCompleto = NombreCompleto;
        this.Nombre = Nombre;
        this.Nombre1 = Nombre1;
        this.Apellido = Apellido;
        this.Apellido1 = Apellido1;
        this.RazonSoc = RazonSoc;
        this.Correo = Correo;
        this.Celular = Celular;
        this.Telefono = Telefono;
        this.DeptoCod = DeptoCod;
        this.DeptoNom = DeptoNom;
        this.MunCod = MunCod;
        this.MunNom = MunNom;
        this.Direccion = Direccion;
        this.EsPropietario = EsPropietario;
        this.ModificarNomSusc = ModificarNomSusc;
        this.PorcPropMayor = PorcPropMayor;
        this.NumeroCuenta = NumeroCuenta;
        this.AutorizaInfo = AutorizaInfo;
        this.AceptaTratDatosPer = AceptaTratDatosPer;
        this.RecibirFactElect = RecibirFactElect;
        this.MatCatastral = MatCatastral;
        this.FechaCreacion = FechaCreacion;
      }
  
  }